export default "__VITE_ASSET__CMXXJRRq__"